import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import Selectsearch from "react-select";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import DatePicker from "react-datepicker";
import moment from 'moment';
import {
	FormGroup,
	Label,	
} from 'reactstrap';

import {
   allStudents,
   studentOCScoring,
   fetchOnScoringChart,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';

 import ViewReport from './component/viewreport';
 import AddItem from '../nineeighthole/component/addform';

class onscoringreport extends Component {
   
   constructor(props) {
      
      super(props);
      let startDate = new Date();
      let befrstart=new Date(startDate.setMonth(startDate.getMonth() - 2));
      
         this.state = {
            student:'',
            startdate:befrstart,
            enddate:new Date(),
            viewdiv1:true,
            viewdiv2:false,
            viewdiv3:false,
            adddiv:false,
            loader:false,  
            selectdates:'',
            seldata:[],
            dacheckbox:false,
            allcourse:[],
         };  
 
         this.onBackSection = this.onBackSection.bind(this); 
        this.ViewReport = this.ViewReport.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.addEntry = this.addEntry.bind(this);
   }  

   UNSAFE_componentWillMount() {
	   this.props.allStudents();
	} 

   selstudent(evt){
        var student=evt.value;
        var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        
        this.setState({ 
            loader:true,
            student: student,  
            viewdiv2:false,
        });

        this.props.studentOCScoring(student, stdate, eddate).then((data) => {   
            this.setState({ 
                loader:false,
                viewdiv2:true,               
                
            });

        });
    }

    selectstart = (date) => {  
        this.setState({ startdate:date });           
    }

    selectend = (date) => {  
        this.setState({ enddate:date });           
    }

    handleSubmit(evt){
        evt.preventDefault();   
        var student=this.state.student;
        var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        
        this.setState({ 
            loader:true,
            viewdiv2:false,
        });

        this.props.studentOCScoring(student, stdate, eddate).then((data) => {   
            this.setState({ 
                loader:false,
                viewdiv2:true,
            });

        });
        
        
    } 

    ViewReport(){
        var seldate=this.state.seldata;
        var alldate=seldate.join(',');
        var student=this.state.student;
        var course=''; 
        this.setState({ 
            loader:true,           
        });

        this.props.fetchOnScoringChart(student, alldate, course).then((data) => {   
            var resdata=data;
            var course=[];
            var rescourse=resdata.courses;
            if(resdata.length!=0){
                {rescourse.map((teamval, idx) => (                     
                    course.push({
                        id:teamval.ccb_clubID,
                        name:teamval.course,
                    })                    
                ))}
            }

            this.setState({ 
                allcourse:course,
                loader:false, 
                viewdiv2:false,
                viewdiv3:true,              
            });
        });

    }
    
    handleChange(id, event){

        if (event.target.checked) {
           var seldate=event.target.value;
           this.setState({ seldata: [...this.state.seldata, seldate] })
        }else{
            var array = [...this.state.seldata]; 
            var index = array.indexOf(event.target.value)
            if (index !== -1) {
                array.splice(index, 1);
                this.setState({seldata: array});
            }
        }


    }

    onBackSection() {
		this.setState({ 
            seldata:[],   
            viewdiv3:false,
            adddiv:false,
            viewdiv2:true,
       });
	} 

    addEntry(){
        this.setState({ 
            seldata:[],   
            viewdiv3:false,
            viewdiv2:false,
            adddiv:true,
       });
    }

    render() {
      const { match, studentlists, ocscoringlist, loading } = this.props;

        const allstudent=studentlists.map((stdval) => {  
            return {
                label: stdval.student,  
                value: stdval.uudID
            }
        });
        

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>On Course Scoring Report  | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.oncscoringreport" />} match={match} />
             <div className="row" >
                        {this.state.viewdiv1 &&                             
                            <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                                <RctCollapsibleCard>                              
                                    <form autoComplete="off" id="addform" onSubmit={(e)=>this.handleSubmit(e)}>              
                                        <div className="row">      
                                            <div className="col-lg-4">
                                            <FormGroup>
                                                <Label for="Select">Student *</Label>
                                                <Selectsearch id="student" name="student" placeholder="Select Student *" options={allstudent} value={allstudent.find(obj => obj.value === this.state.student)} onChange={evt => this.selstudent(evt)} required/>
                                            </FormGroup>
                                            </div>                                              
                                            <div className="col-lg-3">
                                                <FormGroup >
                                                    <DatePicker className="form-control" id="startdate" placeholderText="Start Date"  name="startdate" required autoComplete="off" 
                                                            selected={this.state.startdate}
                                                            onChange={this.selectstart}
                                                            dateFormat='yyyy-MM-dd'
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown 
                                                        /> 
                                                </FormGroup>                                          
                                            </div>
                                            <div className="col-lg-3">
                                                <FormGroup >
                                                    <DatePicker className="form-control" id="enddate" placeholderText="End Date"  name="enddate" required autoComplete="off" 
                                                            selected={this.state.enddate}
                                                            onChange={this.selectend}
                                                            dateFormat='yyyy-MM-dd'
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                        /> 
                                                </FormGroup>                                          
                                            </div>
                                            <div className="form-group">                       
                                                <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Filter"/>                                            
                                            </div>              
                                        </div>
                                    </form>  
                                </RctCollapsibleCard>                                                    
                            </div>
                        }
                </div>

               {this.state.viewdiv2 && 
                    <div className="col-sm-12 col-lg-6" style={{margin:"0 auto"}}>
                        <RctCollapsibleCard heading="List" fullBlock>
                            <div className="col-md-12">
                            <div className="as"> 
                            <button type="button" className="mr-3 mb-3 btn btn-outline-primary float-left" onClick={this.addEntry} >Add Score</button>
                                 <button type="button" className="mr-3 mb-3 btn btn-outline-success float-right" onClick={this.ViewReport} >View Report</button>   
                            </div>   
                            </div>
                            <div className="table-responsive">
                                <Table>
                                    <TableHead>
                                        <TableRow hover>   
                                        <TableCell>No</TableCell>
                                            <TableCell>NAME</TableCell>
                                            <TableCell>DATE</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                    {ocscoringlist.map((element, i) => (
                                            
                                        <TableRow key={i}>
                                            <TableCell><input type="checkbox" name={'datecheckbox'} value={element.gne_date}  onChange={e => this.handleChange(i, e)} className="form-control form-control-alternative"/></TableCell>
                                            <TableCell>{element.student}</TableCell>
                                            <TableCell>{element.cdate}</TableCell> 
                                        </TableRow>
                                    ))}
                                    </TableBody>
                                </Table>   
                            </div>   
                        </RctCollapsibleCard>
                    </div>
                }

                {this.state.viewdiv3 && 
                  <ViewReport onClick={this.onBackSection} data={this.state}/>
                }

                {this.state.adddiv&&
                 <AddItem onClick={this.onBackSection} data={this.state}/>
                }

                {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                }

                               
          </div>
       )
    }
 }

const mapStateToProps = ({ mostlyused, ocscoring }) => {
	const { studentlists, loading } = mostlyused;
    const { ocscoringlist } = ocscoring;
	return { studentlists, ocscoringlist, loading };
}

export default connect(mapStateToProps, {
   allStudents,
   studentOCScoring,
   fetchOnScoringChart,
})(onscoringreport); 